import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { PORT_WAREHOUSE_TYPES } from 'constants/ports';
import './Warehouses.scss';

const WarehousesApproval = ({
    originalValues = {}, changedValues = {}, onApprove, onReject, 
}) => (
    <div className="warehouses-block">
        <div className="warehouses-grid">
            {PORT_WAREHOUSE_TYPES.map(({ name, label }) => (
                <div 
                    key={name} 
                    className={changedValues[name] !== originalValues[name] ? 'dirty-element' : ''}
                >
                    <Checkbox
                        checked={changedValues[name] || false}
                        label={label}
                        disabled
                    />
                </div>
            ))}
        </div>
        <div className="form-actions">
            <RaisedButton
                label="Approve"
                primary
                onClick={() => onApprove('warehouses')}
            />
            <RaisedButton
                label="Reject"
                secondary
                onClick={() => onReject('warehouses')}
            />
        </div>
    </div>
);

export default WarehousesApproval;



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/Warehouses/WarehousesApproval.jsx